import { createAuth0Config } from '@lucid/auth';
import { authDebugInfo, authDebugWarn, redactClientId } from '../utils/authDebug';

const auth0Domain = import.meta.env.VITE_AUTH0_DOMAIN;
const auth0ClientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
const auth0Audience = import.meta.env.VITE_AUTH0_AUDIENCE;

authDebugInfo('Initializing Auth0 config', {
  env: import.meta.env.VITE_ENV ?? 'unknown',
  origin: window.location.origin,
  domainConfigured: Boolean(auth0Domain),
  domain: auth0Domain || 'missing',
  clientId: redactClientId(auth0ClientId || ''),
  audienceConfigured: Boolean(auth0Audience),
});

if (!auth0Domain || !auth0ClientId) {
  authDebugWarn('Auth0 config is missing required values', {
    domainConfigured: Boolean(auth0Domain),
    clientIdConfigured: Boolean(auth0ClientId),
  });
}

export const auth0Config = createAuth0Config({
  domain: auth0Domain,
  clientId: auth0ClientId,
  audience: auth0Audience,
});
